import React from 'react';
import BaseModal from '@src/components/modal';
import InviteCodeComp from './invite-code';

const InviteFormModal = {
  self: null,
  show(data = {}) {
    this.self = BaseModal.show({
      wrapClassName: 'nw-base-modal nw-base-modal-p-0 invite-code-modal',
      borderRadius: 24,
      // closable: false,
      content: (
        <InviteCodeComp
          {...data}
          onClose={() => {
            this.close();
          }}
        ></InviteCodeComp>
      ),
      afterClose: () => {
        this.close();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
      // store.resetForm();
    }
  },
};

export default InviteFormModal;
